import { render, staticRenderFns } from "./email-confirmation.vue?vue&type=template&id=e7fb92e2&"
import script from "./email-confirmation.vue?vue&type=script&lang=js&"
export * from "./email-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./email-confirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports